import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatError } from "@/context/AuthContext";

const HERO = "https://static.prod-images.emergentagent.com/jobs/58fc8f05-e99b-4946-b4cb-e7f6df7eb0e5/images/17f56cc1783288e9e899cd71e175de00652322b80183799471a7e0e74524072e.jpeg";
const LOGO = "https://static.prod-images.emergentagent.com/jobs/58fc8f05-e99b-4946-b4cb-e7f6df7eb0e5/images/94db3a8fd9595299dc077527071a054f31c15ec9f83972e813d55c616ce12086.jpeg";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: "", password: "" });
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const u = await login(form.email, form.password);
            toast.success("Welcome back.");
            navigate(u.role === "admin" ? "/admin" : "/account");
        } catch (err) { toast.error(formatError(err.response?.data?.detail)); setBusy(false); }
    };

    const input = "w-full bg-surface border border-gold/20 rounded-xl px-4 py-3 text-cream placeholder:text-faded focus:outline-none focus:ring-1 focus:ring-gold";

    return (
        <div className="min-h-[calc(100vh-72px)] grid md:grid-cols-2">
            <div className="relative hidden md:block">
                <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-ink/75" />
                <div className="relative z-10 h-full flex flex-col items-center justify-center p-12 text-center">
                    <img src={LOGO} alt="Sacred Earthworks" className="w-60 rounded-2xl border border-gold/20" />
                    <p className="mt-8 font-serif text-3xl text-cream leading-tight">The iron is in the dirt.<br />The house is guarded.</p>
                </div>
            </div>
            <div className="flex items-center justify-center p-8">
                <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
                    <span className="overline-label">Welcome Back</span>
                    <h1 className="mt-3 font-serif text-4xl text-cream mb-8">Sign In</h1>
                    <div className="space-y-4">
                        <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="login-email" />
                        <input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={input} data-testid="login-password" />
                    </div>
                    <button disabled={busy} data-testid="login-submit" className="mt-6 w-full bg-gold text-ink rounded-full py-3 font-medium hover:bg-goldbright transition-colors active:scale-95 disabled:opacity-60">
                        {busy ? "Signing in…" : "Sign In"}
                    </button>
                    <p className="mt-6 text-sm text-ash text-center">New here? <Link to="/register" className="text-gold hover:text-goldbright">Create an account</Link></p>
                </form>
            </div>
        </div>
    );
}
